import { Component } from '@angular/core';

@Component({
    selector: 'app-list-notifications',
    templateUrl: './list-notifications.component.html',
    styleUrl: './list-notifications.component.css'})
export class ListNotificationsComponent {

}
